import { createSlice } from '@reduxjs/toolkit';
import { IDocumentConvert } from './DocumentConvert.type';

export interface DocumentConvertState {
  isLoading: boolean;
  isReloadListDocument: boolean;
  documentSelected: IDocumentConvert | null;
  documentDetail: any;
  expandedDocumentTree: boolean;
  isReloadDocument: boolean;
}

const initialState: DocumentConvertState = {
  isLoading: false,
  isReloadListDocument: false,
  documentSelected: null,
  documentDetail: null,
  expandedDocumentTree: true,
  isReloadDocument: false,
};

const documentConvertSlice = createSlice({
  name: 'document-convert',
  initialState,
  reducers: {
    setDocumentSelected: (state, action) => {
      state.documentSelected = action.payload;
    },
    setDocumentDetail: (state, action) => {
      state.documentDetail = action.payload;
    },
    setExpandedDocumentTree: (state, action) => {
      state.expandedDocumentTree = action.payload;
    },
    triggerReloadListDocument: state => {
      state.isReloadListDocument = !state.isReloadListDocument;
    },
    triggerReloadDocument: state => {
      state.isReloadDocument = !state.isReloadDocument;
    },
  },
  extraReducers: builder => {},
});

export const {
  triggerReloadListDocument,
  setDocumentSelected,
  setDocumentDetail,
  setExpandedDocumentTree,
  triggerReloadDocument,
} = documentConvertSlice.actions;

export default documentConvertSlice.reducer;
